"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function setRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        var refObj = ref;
        refObj.current = value;
    }
}
exports.setRef = setRef;
function combineRefs(refs, value) {
    refs.forEach(function (ref) {
        if (ref) {
            setRef(ref, value);
        }
    });
}
exports.combineRefs = combineRefs;
function useForkRef(refA, refB) {
    return react_1.useMemo(function () {
        if (!refA && !refB) {
            return null;
        }
        return function (refValue) {
            setRef(refA, refValue);
            setRef(refB, refValue);
        };
    }, [refA, refB]);
}
exports.default = useForkRef;
